// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"352":"885012b3","956":"84725af8"}[chunkId] + ".js";
};